if (!global._babelPolyfill) {
    require('babel-polyfill')
};

import React from "react";
import { connect } from "react-redux";

let browserHistory = require("react-router").browserHistory;

import * as actionTypes from "../actions/actionTypes";
let actions = require("../actions/actions");
let StarRating = require("./moderation-star-rating");

export class ReviewCreatorModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.result.actionType === actionTypes.COMPLETE_UPLOAD_SUCCESS
        ) {
            browserHistory.push("/fort/modparty/creators/");
            this.props.dismissModal();
        }
    }

    render() {
        if (this.props.upload.error) {
            return (
                <section className="modal-overlay creator-rating row">
                    <div className="no-results" style={{ color: "black" }}>
                        This is awkward, but there is not a new upload to review at the moment.
                        <Link
                            to={"/fort/modparty/save-for-later/"}
                            className="btn btn-default"
                            style={{ display: "block", margin: "20px 40px" }}
                        >
                            Go To Save For Later
                        </Link>
                    </div>
                </section>
            );
        }

        let creator = this.props.upload.creator;

        return (
            <section className="modal-overlay creator-rating row">
                <h2>How would you rate this Creator's Icons?</h2>
                <StarRating starRating={0} creator={creator} editable={true} />
                <div className="star-info">
                    <span className="awful">Awful</span>
                    <span className="bad">Bad</span>
                    <span className="okay">Okay</span>
                    <span className="great">Great</span>
                    <span className="excellent">Excellent</span>
                </div>
                <a
                    href="/fort/modparty/under-review/2/"
                    className="btn default-btn black finish-reviewing"
                    onClick={this.submitRating.bind(this)}
                >
                    Submit Rating
                </a>
            </section>
        );
    }

    submitRating(e) {
        e.preventDefault();

        this.props.completeUpload(this.props.upload.id);
    }
}

export default connect(null, {
    completeUpload: actions.completeUpload,
    fetchUploadIcons: actions.fetchUploadIcons
})(ReviewCreatorModal);
